<template>
    <div
            class="home-large-cover overflow-hidden"
    >
        <div class="content position-relative">
            <div
                    :style="{background: computedOverlayColor}"
                    class="overlay position-absolute"
            >
                <div class="gradient w-100 h-100"/>
            </div>

            <b-row>
                <b-col
                        sm="12"
                        xl="6"
                >
                    <div class="headline mx-auto">
                        <p class="title">
                            Everything you need to manage your home and track its value.
                        </p>
                    </div>


                    <address-type-ahead
                            ref="addressTypeAhead"
                            v-model="address"
                            :allow-user-value="true"
                            :has-focusable-state="false"
                            class="input-group prepend-icon-input-group"
                            input-class="border-left-0 border-right-0 pr-0 pl-0"
                            placeholder-fallback="Enter your home address"
                            resource-type=""
                            @input="handleAddressInput"
                            @set-resource="handleClaimMyHomeClick"
                    >
                        <template v-slot:before>
                            <b-input-group-prepend>
                                <b-button
                                        class="d-flex align-items-center"
                                        disabled
                                >
                                    <i
                                            class="far fa-map-marker-alt"
                                    />
                                </b-button>
                            </b-input-group-prepend>
                        </template>
                        <template
                                v-if="!isMobile"
                                v-slot:after
                        >
                            <b-input-group-append class="px-1 py-1 ">
                                <b-button
                                        class="px-4 btn-lg mx-auto"
                                        variant="primary"
                                        @click="handleClaimMyHomeBTNClick"
                                >
                                    Claim My Home
                                </b-button>
                            </b-input-group-append>
                        </template>
                    </address-type-ahead>
                    <div class="claim-my-home">
                        <b-input-group-append
                                v-if="isMobile"
                                class="py-1 "
                        >
                            <b-button
                                    class="px-4 btn-lg mx-auto"
                                    variant="primary"
                                    @click="handleClaimMyHomeBTNClick"
                            >
                                Claim My Home
                            </b-button>
                        </b-input-group-append>
                    </div>
                </b-col>

                <b-col
                        offset-lg="1"
                        sm="12"
                        xl="5"
                >
                    <b-img
                            :src="require('../../../../../assets/images/landingPages/homeOwnership/home-hero.png')"
                            class="d-block"
                            fluid
                    />
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import "./HomeLargeCover.scss";
import "./HomeLargeCover.mobile.scss";
import AddressTypeAhead from "@milestoneslabs/milestones-ui-kit/src/components/AddressTypeAhead/AddressTypeAhead";
import IsMobileMixin from "@milestoneslabs/milestones-ui-kit/src/mixins/IsMobileMixin";

export default {
    name: "HomeLargeCover",

    props: {
        overlayColor: {
            type: String,
            default: '#3D465E'
        },
    },
    components: {
        AddressTypeAhead,
    },
    mixins: [
        IsMobileMixin
    ],

    data() {
        return {
            address: null,
        };
    },

    computed: {
        computedOverlayColor() {
            return this.overlayColor || '#3D465E';
        }
    },
    methods: {
        handleAddressInput(address) {
            this.$emit('addressInput', address);
        },
        handleClaimMyHomeClick(address) {
            this.$emit('click-claim-my-home', address ? address : this.address);
        },
        handleClaimMyHomeBTNClick() {
            this.$refs.addressTypeAhead.$refs.typeAheadInput.focus();
        }
    },
};
</script>
